import { render, staticRenderFns } from "./booster-pricing.vue?vue&type=template&id=23bb09aa&"
import script from "./booster-pricing.vue?vue&type=script&lang=js&"
export * from "./booster-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports